export enum Feature {
  Layout = 'layout',
  Analytics = 'analytics',
  Auth = 'auth',
  BillingProfiles = 'billing-profiles',
  CompanySettings = 'company-settings',
  Compass = 'compass',
  CompassEmbed = 'compass-embed',
  CustomFields = 'custom-fields',
  Deactivation = 'deactivation',
  DomainVerification = 'domain-verification',
  DynamicColumns = 'dynamic-columns',
  ExportProjectList = 'export-project-list',
  FileUpload = 'file-upload',
  Gantt = 'gantt',
  GlobalTasks = 'global-tasks',
  HelpCenter = 'help-center',
  Home = 'home',
  Impersonation = 'impersonation',
  Integrations = 'integrations',
  Labs = 'labs',
  Labels = 'labels',
  MergeTags = 'merge-tags',
  Messages = 'messages',
  Navigation = 'navigation',
  Notifications = 'notifications',
  OpenApi = 'open-api',
  Portal = 'portal',
  ProgramManagement = 'program-management',
  Profile = 'profile',
  ProjectCustomFields = 'project-custom-fields',
  ProjectCreation = 'project-creation',
  ProjectFilters = 'project-filters',
  ProjectAttachments = 'project-attachments',
  ProjectList = 'project-list',
  ProjectNotes = 'project-notes',
  ProjectOverview = 'project-overview',
  ProjectPlan = 'project-plan',
  Reports = 'reports',
  ServerAction = 'server-action',
  SharedProjectOverview = 'shared-project-overview',
  TaskActions = 'task-actions',
  TaskDrawer = 'task-drawer',
  Teams = 'teams',
  TemplateLibrary = 'template-library',
  TemplateImporter = 'template-importer',
  Trials = 'trials',
  Workato = 'workato',
  Workspaces = 'workspaces',
  TimeTracking = 'time-tracking',
  ResourceManagement = 'resource-management',
  WorkspaceFeatures = 'workspace-features',
  TaskResourcePlanning = 'task-resource-planning',
  PeopleTimeline = 'people-timeline',
  ProjectMigration = 'project-migration',
}

export function isDevelopmentEnvironment(): boolean {
  return process.env.NEXT_PUBLIC_APP_ENV === 'development'
}

export function isStagingEnvironment(): boolean {
  return (
    process.env.NEXT_PUBLIC_APP_ENV === 'staging' ||
    process.env.NEXT_PUBLIC_APP_ENV === 'preview'
  )
}
